import '../../../common/dashboard/filters/applied/applied_filter_view.js.coffee'
import '../groups_filter_mixin.js.coffee'

Namespace 'CustomerVisualMode.Filters.Applied'

FILTERS = Common.Dashboard.Filters

class CustomerVisualMode.Filters.Applied.AppliedGroupsFilterView extends FILTERS.AppliedMultipleValuesFilterView
  initialize: ({filter, groups, isReadOnly}) ->
    super({filter, isReadOnly})
    _.extend(@, CustomerVisualMode.Filters.GroupsFilterMixin)
    @groups = groups
    filters = Common.Dashboard.Filters
    @appliedPrimaryGroupsView = new filters.AppliedPrimaryGroupedElementsView({filter, isReadOnly})
    @appliedSecondaryGroupsView = new filters.AppliedSecondaryGroupedElementsView({filter, isReadOnly})
    @appliedExcludedGroupsView = new filters.AppliedExcludedGroupedElementsView({filter, isReadOnly})

  _renderValues: =>
    container = @$('.applied-filter-values-container')
    container.empty()
    @_renderAppliedGroupView(container, @appliedPrimaryGroupsView)
    @_renderAppliedGroupView(container, @appliedSecondaryGroupsView)
    @_renderAppliedGroupView(container, @appliedExcludedGroupsView)

  _renderAppliedGroupView: (container, view) ->
    container.append(view.render().el) if view.shouldRender()

  _shouldRenderButton: ->
    !@isReadOnly

  _displayTitle: ->
    I18n.t('customer_visual_mode.filters.groups')

  _seeAll: ->
    @renderModal(@filter, @groups)
